import Chip from "@mui/material/Chip"
import { lighten, styled } from "@mui/material/styles"

export default styled(Chip, {
  shouldForwardProp: (prop) => prop !== "role",
})(({ theme, role }) => {
  let color, bgColor

  switch (role) {
    case ROLE_AGENT:
      color = theme.palette.primary.main
      bgColor = theme.palette.colors.brand50
      break
    case ROLE_BROKER:
      color = theme.palette.success700
      bgColor = theme.palette.colors.success50
      break
    default:
      color = theme.palette.colors.gray600
      bgColor = theme.palette.colors.gray50
  }

  return {
    backgroundColor: bgColor,
    color: color,
    fontWeight: 600,
    fontSize: "12px",
    height: "22px",
    borderRadius: "16px",
    border: `1px solid ${lighten(color, 0.2)}`,
    backdropFilter: "blur(4px)",
    "& .MuiChip-label": {
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  }
})

const ROLE_AGENT = "agent"
const ROLE_BROKER = "broker"
const ROLE_OTHER = "other"

export const AGENT_ROLES = {
  [ROLE_AGENT]: "Agent",
  [ROLE_BROKER]: "Broker",
  [ROLE_OTHER]: "Other",
}
